<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-0.61,802.5l-8.89-8.89v-2.22l8.89-8.89h2.22l8.89,8.89v2.22l-8.89,8.89H-0.61z M-0.61,800.28h2.22v-3.33l3.33-3.33h3.33
	v-2.22H4.94l-3.33-3.33v-3.33h-2.22v3.33l-3.33,3.33h-3.33v2.22h3.33l3.33,3.33V800.28z"/>
</svg>

</template>